import React from 'react';
import { createBrowserRouter,  RouterProvider } from 'react-router-dom';
import HomePage from '../routes/HomePage';
import CategoryPage from '../routes/CategoryPage';
import CategoryVideoPlay from '../routes/CategoryVideoPlay';
import SubscriptionPage from '../routes/SubscriptionPage';
import OtpVerify from '../routes/OtpVerify';

const Routing = () => {
    
    const router=createBrowserRouter([{
        path:"/home",
        element:<HomePage />
    },
    {
        path:"/category/:category_name",
        element:<CategoryPage />
    },
    {
        path:"/category/video/play",
        element:<CategoryVideoPlay />
    },
    {
        path:"/",
        element:<SubscriptionPage />
    },{
        path:"/otp",
        element:<OtpVerify />
    }
])
  
    return (
    <RouterProvider router={
        router
    } />
  )
}

export default Routing